import React from 'react';
import { Clock, Loader2, CheckCircle2, XCircle } from 'lucide-react';
import { PROXY_STATUS_META, CARD_INGEST_SPIN_KEYFRAMES, formatTimestamp } from './theme';

const ICONS = { Clock, Loader2, CheckCircle2, XCircle };

// Adobe Media Encoder-style queue list: one row per file, a status badge
// that updates live, greyed out once done, with the completion timestamp.
export default function ProxyJobList({ c, jobs }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', maxHeight: '260px', overflow: 'auto' }}>
      <style>{CARD_INGEST_SPIN_KEYFRAMES}</style>
      {jobs.map((job) => {
        const meta = PROXY_STATUS_META[job.status] || PROXY_STATUS_META.queued;
        const Icon = ICONS[meta.iconName];
        const done = job.status === 'completed' || job.status === 'failed' || job.status === 'cancelled';
        const statusColor = job.status === 'completed' ? c.ok : job.status === 'failed' ? c.err : job.status === 'running' ? c.accent : c.muted;
        return (
          <div
            key={job.id}
            style={{
              display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 8px',
              borderRadius: '6px', background: done ? 'transparent' : c.subtleBg,
              opacity: job.status === 'completed' ? 0.6 : 1,
            }}
          >
            <Icon size={13} color={statusColor} style={meta.spin ? { animation: 'cardIngestSpin 1s linear infinite' } : undefined} />
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: '11px', fontWeight: 500, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {job.sourcePath.split(/[\\/]/).pop()}
              </div>
              {job.status === 'failed' && job.error && (
                <div style={{ fontSize: '10px', color: c.err, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{job.error}</div>
              )}
            </div>
            <span style={{ fontSize: '10px', color: statusColor, fontWeight: 600, letterSpacing: '0.02em' }}>{meta.label}</span>
            {done && (
              <span style={{ fontSize: '10px', color: c.muted, minWidth: '60px', textAlign: 'right' }}>{formatTimestamp(job.updatedAt)}</span>
            )}
          </div>
        );
      })}
    </div>
  );
}
